import { RESHOP_ACTIVATED_CAMPAIGNS_KEY_NAME } from "../../pdv-one/constants/keyNamesSessionStorage";

export const activatedCampaignsService = () => {
  const activatedCampaigns = sessionStorage.getItem(RESHOP_ACTIVATED_CAMPAIGNS_KEY_NAME);

  return (JSON.parse(activatedCampaigns || "[]") || []);
}
